module.exports = __webpack_public_path__ + "static/img/ChampionsForSight_PrimaryLogo_White.9cded5b.png";


//////////////////
// WEBPACK FOOTER
// ./static/assets/img/logo/ChampionsForSight_PrimaryLogo_White.png
// module id = 365
// module chunks = 4